import { preInsert, preRemove, preSave } from '@/rxdb/defaultHooks';
import defaultReplication from '@/rxdb/defaultReplication';

export const references = {
    schema: {
        title: 'references schema',
        version: 1,
        description: 'describes a references',
        primaryKey: 'id',
        type: 'object',
        properties: {
            id: { type: 'string', final: true, maxLength: 40 },
            name: { type: ['string', 'null'] },
            dates: {
                type: ['array', 'null'],
                items: {
                    type: 'object',
                    properties: {
                        startDate: { type: ['string', 'null'] },
                        endDate: { type: ['string', 'null'] },
                        taskId: { type: 'string' },
                    },
                },
            },
            createdBy: { type: ['string', 'null'], final: true },
            updatedAt: { type: ['string', 'null'] },
            deletedAt: { type: ['string', 'null'] },
            deletedBy: { type: ['string', 'null'] },
            createdAt: { type: ['string', 'null'] },
            updatedBy: { type: ['string', 'null'] },
            projectId: { type: ['string', 'null'] },
            rootVersion: { type: ['string', 'null'] },
        },
    },
    options: {
        onCollectionCreated(projectId, rxCollection) {
            rxCollection.replicationState = defaultReplication(rxCollection, projectId);
            rxCollection.preRemove(preRemove, false);
            rxCollection.preInsert(preInsert, false);
            rxCollection.preSave(preSave, false);
        },
    },
    migrationStrategies: {
        1: (doc) => doc,
    },
};
